import React from "react";

export const CercleIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="37"
        viewBox="0 0 37 37"
        fill="none">
        <path
          d="M18.3339 36.6678C15.7977 36.6678 13.4143 36.1865 11.1837 35.224C8.95305 34.2615 7.01272 32.9552 5.36267 31.3051C3.71261 29.6551 2.40632 27.7147 1.44379 25.4841C0.481265 23.2535 0 20.8701 0 18.3339C0 15.7977 0.481265 13.4143 1.44379 11.1837C2.40632 8.95305 3.71261 7.01272 5.36267 5.36267C7.01272 3.71261 8.95305 2.40632 11.1837 1.44379C13.4143 0.481265 15.7977 0 18.3339 0C20.8701 0 23.2535 0.481265 25.4841 1.44379C27.7147 2.40632 29.6551 3.71261 31.3051 5.36267C32.9552 7.01272 34.2615 8.95305 35.224 11.1837C36.1865 13.4143 36.6678 15.7977 36.6678 18.3339C36.6678 20.8701 36.1865 23.2535 35.224 25.4841C34.2615 27.7147 32.9552 29.6551 31.3051 31.3051C29.6551 32.9552 27.7147 34.2615 25.4841 35.224C23.2535 36.1865 20.8701 36.6678 18.3339 36.6678ZM18.3339 33.001C22.4285 33.001 25.8966 31.5801 28.7384 28.7384C31.5801 25.8966 33.001 22.4285 33.001 18.3339H18.3339V3.66678C14.2393 3.66678 10.7712 5.08766 7.92941 7.92941C5.08766 10.7712 3.66678 14.2393 3.66678 18.3339C3.66678 22.4285 5.08766 25.8966 7.92941 28.7384C10.7712 31.5801 14.2393 33.001 18.3339 33.001Z"
          fill="#4060F3"
        />
      </svg>
    </div>
  );
};
